import { Lock } from 'lucide-react';

interface LockedNodeOverlayProps {
  managedByTemplateId?: string;
  unlocked?: boolean;
  children: React.ReactNode;
}

export function LockedNodeOverlay({ managedByTemplateId, unlocked, children }: LockedNodeOverlayProps) {
  const isLocked = !!managedByTemplateId && !unlocked;

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      <div className="pointer-events-none opacity-50">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex items-center gap-2 bg-background/80 px-3 py-2 rounded-md border border-border text-sm text-muted-foreground">
          <Lock className="h-4 w-4" />
          <span>Locked by template. Unlock to edit.</span>
        </div>
      </div>
    </div>
  );
}

interface LockedFieldOverlayProps {
  managedByTemplateId?: string;
  unlocked?: boolean;
  children: React.ReactNode;
}

export function LockedFieldOverlay({ managedByTemplateId, unlocked, children }: LockedFieldOverlayProps) {
  const isLocked = !!managedByTemplateId && !unlocked;

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <div className="pointer-events-none opacity-50">
      {children}
    </div>
  );
}

interface LockedFieldIndicatorProps {
  managedByTemplateId?: string;
  unlocked?: boolean;
}

export function LockedFieldIndicator({ managedByTemplateId, unlocked }: LockedFieldIndicatorProps) {
  if (!managedByTemplateId) return null;

  const isLocked = !unlocked;
  return (
    <Lock className={`h-3 w-3 ${isLocked ? 'text-muted-foreground' : 'text-muted-foreground/40'}`} />
  );
}
